module.exports = __webpack_public_path__ + "img/coffee-beans.06f49e4b.png";